export default {
  loginBegin(state) {
    state.login = true;
  },
  loginSuccess(state, data) {
    console.log('esto llega a loginSucces data -> ', data);
    state.loading = false;
    
    state.data = data;
  },

  loginErr(state, err) {
    console.log('esta entranto a loginErr --> ', err);
    state.loading = false;
    state.error = err;
  },

  logoutBegin(state) {
    state.loading = false;
  },

  logoutSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },

  logoutErr(state, err) {
    state.loading = false;
    state.error = err;
  },
};
